// Core
import React from 'react'

// Library
import clsx from 'clsx'

// Styles
import classes from 'components/Onboarding/PermissionDisclaimer/PermissionDisclaimer.module.scss'

// Interface
interface IpermissiondisclaimerProps {
  quote: string
}

export default function PermissionDisclaimer({
  quote,
}: IpermissiondisclaimerProps) {
  return (
    <div className={clsx(classes.container)}>
      <blockquote>{quote}</blockquote>
    </div>
  )
}
